import {Injectable} from "@angular/core";
import {NestApiProvider} from "../../nest-api";
import {Observable} from "rxjs";
import {
  RequestSaveChangeDto,
  ResponseGetAllDataEmpDto,
  ResponseSaveChangeDto,
} from "../dto/sf-change-spv.dto";

@Injectable()
export class SfChangeSpvApi {
  private readonly service: string = '';
  private readonly model: string = 'sfChangeSpv';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public getAllDataEmp(): Observable<ResponseGetAllDataEmpDto> {
    const method: string = 'POST';
    const func: string = 'getAllDataEmp';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseGetAllDataEmpDto>(method, url, params, urlParams, body);
  }

  public saveChange(payload: RequestSaveChangeDto): Observable<ResponseSaveChangeDto> {
    const method: string = 'POST';
    const func: string = 'saveChange';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseSaveChangeDto>(method, url, params, urlParams, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/sf-change-spv.api.ts